var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt',{staticClass:"page-content notranslate"}),_vm._v(" "),_c('BaseNotifications'),_vm._v(" "),_c('portal-target',{attrs:{"name":"preview-layout"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }